'use es6';

import { USER_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const User = ObjectDefinitionRecord({
  objectTypeId: USER_TYPE_ID,
  referenceObjectType: 'USER_PROPERTIES'
});
export default User;